import useGetNewsTipComments from './useGetNewsTipComments'

export default useGetNewsTipComments
